import API from "../services/http";
import NetworkUtils from "../utils/NetworkUtils";

async function getBuildingDevices() {
    try {
        const response = await API.get('/buildings/getDeviceInfos');
        if (!response.data?.IsSuccess) {
            return { success: false, error: response.data.Message }
        }
        return { success: true, data: response.data.Data };
    } catch (error) {
        return { success: false, message: NetworkUtils.handleAxiosError(error) };
    }
}
async function getBuildings() {
    try {
        const response = await API.get('/buildings/getBuildingInfos');
        if (!response.data?.IsSuccess) {
            return { success: false, error: response.data.Message }
        }
        return { success: true, data: response.data.Data };
    } catch (error) {
        return { success: false, message: NetworkUtils.handleAxiosError(error) };
    }
}


export const BuildingsRepository = {
    getBuildingDevices, getBuildings
}
